import { PERMISSION_OPERATION, PERMISSION_REALM, PERMISSION_RESOURCE } from '@/constants/userPermissions';
import { LICENSE } from '@/constants/license';

export const validatePermission = function (
  availableUserPermissions,
  requiredRealm,
  requiredResource,
  requiredOperation
) {
  if (requiredRealm && requiredResource && requiredOperation) {
    const foundPermission =
      availableUserPermissions &&
      availableUserPermissions.find((permission) => {
        return (
          (permission.realm === requiredRealm.toUpperCase() || permission.realm === PERMISSION_REALM.ALL) &&
          (permission.resource === requiredResource.toUpperCase() || permission.resource === PERMISSION_RESOURCE.ALL) &&
          (permission.operation === requiredOperation.toUpperCase() ||
            permission.operation === PERMISSION_OPERATION.ALL)
        );
      });

    return !!foundPermission;
  }
  return false;
};

export const validateLicense = function (activeLicenses, allowedLicenses) {
  const normalizedActiveLicenses = activeLicenses?.length > 0 ? activeLicenses : [LICENSE.PREMIUM];
  const normalizedAllowedLicenses = allowedLicenses?.length > 0 ? allowedLicenses : [];

  return normalizedActiveLicenses.some((license) =>
    normalizedAllowedLicenses.map((e) => e.licenseType).includes(license.licenseType)
  );
};
